<template>
  <div style="height: 100%">
    <b-navbar toggleable="lg" type="dark" variant="dark" class="fixed-top">
      <b-navbar-brand href="#" @click="goBack" class="back"></b-navbar-brand>
      <img class="logo" src="../assets/logo.png" alt />
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="#"
                      v-for="(item, index) in menu.filter((data) =>
              this.formatMenu(data)
            )"
                      :key="index"
                      @click="getMenuUrl(item.value)">{{ item.title }}</b-nav-item>
        </b-navbar-nav>
        <b-nav-form @submit="submit" v-if="ShowSimulate">
          <b-container fluid>
            <b-row>
              <b-col cols="8" style="padding: 0px">
                <b-form-input size="sm"
                              placeholder="請輸入要變身的帳號"
                              v-model="form.account"
                              required></b-form-input>
              </b-col>
              <b-col cols="4" style="padding-right: 0px">
                <b-button size="sm" Block type="submit">變身啦</b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-nav-form>
        <b-navbar-nav>
          <b-nav-item href="#" @click="logout">登出</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <span id="log" style="color: red" v-show="false"></span>
    <div style="height: 100%; padding-top: 54px" v-html="menuUrl"></div>
  </div>
</template>

<script>
  //import firebase from "firebase";
  import qs from "qs";
  export default {
    computed: {
      ShowSimulate: function () {
        let showSimulate = false;
        let canSimulate = $.map(this.menu, function (item, index) {
          return item.value;
        }).indexOf("FN9998");
        if (canSimulate != -1) {
          showSimulate = true;
        }
        return showSimulate;
      },
    },
    data() {
      return {
        staff: this.GetLoginStaff(),
        menu: [],
        menuUrl: "",
        form: {
          account: "",
        },
      };
    },
    created() {

      if (this.staff == null) {
        alert("登入已逾時，請重新登入");
        window.location.href = "/#/";
      }

      this.setMenu();
      this.getMenuUrl("FN0002");

      if (!("Notification" in window)) {
        return false;
      }

      if (Notification.permission === "denied") {
        return false;
      }

      this.registeFCM(); //servicework
    },
    methods: {
      goBack() {
        this.$router.back(-1);
      },
      logout() {
        window.location.href = "/";

        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        document.cookie =
          "scrmstaff" + "=" + "" + ";expires=" + exp.toGMTString();
        document.cookie =
          "scrmticket" + "=" + "" + ";expires=" + exp.toGMTString();
      },
      getMenuUrl(page) {
        var url = "";
        var ticket = this.GetTicket();

        $.ajax({
          url: this.$conf.MessageAPI + "/SCRMApp/QueryMenuUrl",
          type: "post",
          async: false,
          data: {
            ticket,
            page: page,
          },
          dataType: "json",
          success: function (result) {
            url = result.Url;
          },
          error: function (a, b, c) { },
        });
        var html =
          '<iframe id="ifrmname" name="ifrmname" style="width:100%; height:100%"  src="?t=' +
          Math.random() +
          url +
          '"></iframe>';

        this.menuUrl = html;
      },
      setMenu() {
        var menu = [];
        $.ajax({
          url: this.$conf.MessageAPI + "/SCRMApp/Menu",
          type: "post",
          async: false,
          data: {
            staffId: this.staff.staffid,
            isstaff: this.staff.isstaff,
          },
          dataType: "json",
          success: function (result) {
            menu = result;
          },
          error: function (a, b, c) { },
        });

        this.menu = menu;
      },
      registeFCM() {
        if (!window.Notification) {
          return;
        }

        this.initFirebase();
      },
      sendTokenToServer(token) {
        $("#log").append(token + "<br><br>");
        $.ajax({
          url: this.$conf.MessageAPI + "/WebPush/ReceiveUserToken",
          type: "POST",
          cache: false,
          data: { userToken: token, staffId: this.staff.staffid },
          dataType: "json",
          async: false,
        })
          .done(function (res) {
            //resp = res;
            //console.log(res);
          })
          .fail(function (error) {
            //console.log(error);
          });
      },
      submit(evt) {
        evt.preventDefault();
        this.$axios
          .post(
            "SCRMApp/Simulate",
            qs.stringify({
              UserId: this.form.account,
            })
          )
          .then(function (response) {
            var result = response.data;
            if (result.Success) {
              window.location.href = "/#/Login?token=" + result.Result;
            } else {
              alert(result.DisplayMessage);
            }
          })
          .catch(function (error) {
            alert(error);
          });
      },
      formatMenu: function (obj) {
        return obj.value != "FN9998";
      },
    },
  };
</script>

<style scoped>
  .logo {
    width: 120px;
    display: block;
  }

  .back {
    display: inline-block;
    margin-right: 0.5rem;
    width: 1.5em;
    height: 1.5em;
    background: no-repeat center center;
    background-size: 90% 90%;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIj48Zz48Zz4KCTxnPgoJCTxwYXRoIGQ9Ik00NS44MzMsMjcwLjE0M2MtNy43OTctNy43OTgtNy43OTctMjAuNDg3LDAuMDE4LTI4LjMwMkwyMjEuMTQ1LDY2LjExNGM3LjgtNy44Miw3Ljc4NS0yMC40ODQtMC4wMzUtMjguMjg1ICAgIGMtNy44MjEtNy44LTIwLjQ4NS03Ljc4NS0yOC4yODYsMC4wMzVMMTcuNTQ5LDIxMy41NzJjLTIzLjM5NSwyMy4zOTUtMjMuMzk1LDYxLjQ2Mi0wLjAxOCw4NC44MzlsMTc1LjI5MywxNzUuNzI1ICAgIGMzLjkwOCwzLjkxNyw5LjAzMyw1Ljg3NSwxNC4xNjEsNS44NzVjNS4xMSwwLDEwLjIyMi0xLjk0NywxNC4xMjUtNS44NDFjNy44Mi03LjgwMSw3LjgzNi0yMC40NjUsMC4wMzUtMjguMjg1TDQ1LjgzMywyNzAuMTQzeiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBzdHlsZT0iZmlsbDojRDg4MjgyIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCI+PC9wYXRoPgoJPC9nPgo8L2c+PGc+Cgk8Zz4KCQk8cGF0aCBkPSJNNDkxLjk5OSwyMzUuOTk5SDEyOC45OGMtMTEuMDQ3LDAtMjAuMDAxLDguOTU0LTIwLjAwMSwyMC4wMDFzOC45NTQsMjAuMDAxLDIwLjAwMSwyMC4wMDFoMzYzLjAxOCAgICBjMTEuMDQ3LDAsMjAuMDAxLTguOTU0LDIwLjAwMS0yMC4wMDFTNTAzLjA0NSwyMzUuOTk5LDQ5MS45OTksMjM1Ljk5OXoiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgc3R5bGU9ImZpbGw6I0Q4ODI4MiIgZGF0YS1vbGRfY29sb3I9IiMwMDAwMDAiPjwvcGF0aD4KCTwvZz4KPC9nPjwvZz4gPC9zdmc+");
  }
</style>



// WEBPACK FOOTER //
// src/views/MainMenu.vue